import React from 'react';
import Radium from 'radium';

import {A, Button} from 'views/AppElements';
import HttpService from 'service/HttpService';

import SessionStore from 'stores/SessionStore';
import Modal from 'react-responsive-modal';

import AppUtil from 'AppUtil';

import CoupleProductOrderForm from 'views/order/CoupleProductOrderForm';
import ProductOrderForm from 'views/order/ProductOrderForm';

import ProductStat from 'views/product/ProductStat';
import PhotoFrameForm from 'views/order/PhotoFrameForm';

import OrderListContainer from 'containers/OrderListContainer';

import AppConstants from 'AppConstants';
import MusicPlaqueForm from 'views/order/MusicPlaqueForm';

const PRODUCT_STATE = AppConstants.PRODUCT_STATE;

const styles = {
	productStateMsgBox: {padding: '2px 10px', fontSize: '120%', fontWeight: 'bold', textAlign: 'center', marginBottom: '10px'},
	pendingApprovalMsg: {background: '#f8931b', color: 'white'},
	notPublishedMsg: {background: 'gray', color: 'white'},
	archievedMsg: {background: '#de3a3a', color: 'white'},

	toolBarLink: {marginLeft: '5px', background: '#cc7a18', padding: '5px', 
						borderRadius: '5px', color: 'white', cursor: 'pointer', 
						'@media (max-width: 770px)': {flexGrow: '1'}},
	editLink: {background: 'darkcyan', color: 'white'}
}

const ProductStateMsg = Radium((props) => {
	const productState = props.productState;
	if(!productState)
		return null;

	const isAuthorized = props.isAuthorized;
	let style = [styles.productStateMsgBox];
	let message = null;
	const artworkType = props.artworkType;

	if(productState === PRODUCT_STATE.PENDING_APPROVAL && isAuthorized) {
		style.push(styles.pendingApprovalMsg);
		message = <span><i className="fa fa-exclamation-circle" aria-hidden="true" /> This design is pending approval. <A href={artworkType === AppConstants.ARTWORK_TYPES.PHOTOGRAPH.val? "/faq#photographPendingApproval": "/faq#designPendingApproval"} style={{color: "#3a3837"}}>Learn Why?</A></span>
	} else if (productState === PRODUCT_STATE.UNPUBLISHED) {
		style.push(styles.notPublishedMsg);
		message = <span><i className="fa fa-window-close" aria-hidden="true" /> This design is not published.</span>
	} else if (productState === PRODUCT_STATE.ARCHIVED) {
		style.push(styles.archievedMsg);
		message = <span><i className="fa fa-window-close" aria-hidden="true" /> The design has been archived. It cannot take any order. Please contact us for more info.</span>
	} else {
		return null;
	}
	return <div style={style}>
				{message}
		</div>
});

class ToolBar extends React.Component {
	constructor(props) {
		super(props);
		this.publishProduct = this.publishProduct.bind(this);
		this.unPublishProduct = this.unPublishProduct.bind(this);
		this.publishUnpublishProduct = this.publishUnpublishProduct.bind(this);
		this.deleteProduct = this.deleteProduct.bind(this);
		this.state = {updatingState: false};
	}

	publishProduct() {
		var confirmRes = confirm("Are you sure you want publish the product?");

		if(confirmRes)
			this.publishUnpublishProduct(true);
	}

	unPublishProduct() {
		var confirmRes = confirm("Are you sure you want unpublish the product?");

		if(confirmRes)
			this.publishUnpublishProduct(false);
	}

	publishUnpublishProduct(publish) {
		this.setState({updatingState: true});
		HttpService.publishUnpublishProduct(this.props.product.id, publish, function() {
			this.setState({updatingState: false});
		}.bind(this));
	}

	deleteProduct() {
		var confirmRes = confirm("Are you sure you want delete the product?");


		if(confirmRes) {
			const productId = this.props.product.id;
			HttpService.deleteProduct(productId);
		}
	}

	render() {
		const product = this.props.product;

		const productState = product.productState;

		const productEditURL = AppUtil.getProductEditURL(product);
		const addSubproductURL = AppUtil.getAddSubProductURL(product);

		const isAdmin = this.props.currentUser.userType === AppConstants.USER_TYPE.ADMIN;
		return <div style={{margin: '5px 0', textAlign: 'center', flexWrap: 'nowrap', justifyContent: 'flex-end'}} className='flexRow'>
				{isAdmin && 
					<div style={{padding: '5px', marginRight: 'auto'}}>
						<span style={{cursor: 'pointer', color: '#bb2626'}} onClick={this.deleteProduct}><i className="fa fa-trash" aria-hidden="true"></i></span>

						<A href={addSubproductURL} style={[styles.toolBarLink, styles.editLink]}>
							<i className="fa fa-plus-circle" aria-hidden="true"></i> Add Sub Product
						</A>
					</div>
				}
				
				{
					productState === PRODUCT_STATE.UNPUBLISHED && 
					<Button style={[styles.toolBarLink, {background: 'green'}]} onClick={this.publishProduct} disabled={this.state.updatingState}>
						{
							this.state.updatingState === true && 
							<span><i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i> Publishing</span>
						}
						{
							this.state.updatingState === false && 
							<span>Publish</span>
						}
					</Button>
				}

				{
					productState === PRODUCT_STATE.APPROVED && 
					<Button style={[styles.toolBarLink, {background: '#eee', color: '#9c0f0f'}]} onClick={this.unPublishProduct} disabled={this.state.updatingState}>
						{
							this.state.updatingState === true && 
							<span><i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i> Unpublishing</span>
						}
						{
							this.state.updatingState === false && 
							<span>Unpublish</span>
						}
					</Button>
				}
				<A href={productEditURL} style={[styles.toolBarLink, styles.editLink]} 
						disabled={(productState === PRODUCT_STATE.ARCHIVED && !isAdmin)? true: false}>
						<i className="fa fa-pencil-square-o" aria-hidden="true"></i> Edit
				</A>

				<span href="#" onClick={this.props.onViewOrders} style={styles.toolBarLink}>
					<i className="fa fa-shopping-cart" aria-hidden="true"></i> {product.title} Orders
				</span>
			</div>	
	}
}
ToolBar = Radium(ToolBar);



class ProductDetail extends React.Component {
	constructor(props) {
		super(props);
		this.state = {viewOrders: false, viewSalesTargets: false};

		this.viewOrders = this.viewOrders.bind(this);

		this.getOrderFormToDisplay = this.getOrderFormToDisplay.bind(this);
	}

	viewOrders() {
		this.setState({viewOrders: true});
	}

	onCloseOrdersModal() {
		this.setState({viewOrders: false});
	}


	getOrderFormToDisplay(product) {
		const isCustomProduct = AppUtil.isCustomProduct(product);

		if(isCustomProduct && product.productType === AppConstants.PRODUCT_TYPES['MUSIC_PLAQUE'].val)
			return <MusicPlaqueForm product={product} selectedImage={this.props.selectedImage} />

		if(product && product.productType === AppConstants.PRODUCT_TYPES['PHOTO_FRAME'].val) {
			if(product.imgWidthPx && product.imgHeightPx)
				return <PhotoFrameForm product={product} />
		}
			
		const isCoupleProduct = AppUtil.isCoupleProduct(product);
		if(isCoupleProduct)
			return <CoupleProductOrderForm product={product} selectedImage={this.props.selectedImage} />;

		return <ProductOrderForm product={product} selectedImage={this.props.selectedImage} />
	}

	render() {
		const product = this.props.product;

		const currentSession = SessionStore.getCurrentSession();
		const currentUser = currentSession? currentSession.user: null;
		
		const isAuthorized = product !== null? AppUtil.isAuthorizedForProduct(currentUser, product): false;

		const orderForm = this.getOrderFormToDisplay(product);
		
		return <div className='flexColumn'>
				<ProductStateMsg productState={product? product.productState: null} artworkType={product? product.artworkType: null} isAuthorized={isAuthorized} />
				
				{isAuthorized &&
					<div>
						<ToolBar currentUser={currentUser} product={product} onViewOrders={this.viewOrders} onViewSalesTargets={this.viewSalesTargets} />
						<ProductStat stat={this.props.productStat} product={product} />
					</div>
				}
				
				{orderForm}

				{this.state.viewOrders && 
					<Modal closeOnOverlayClick={false} open={this.state.viewOrders} onClose={this.onCloseOrdersModal.bind(this)} 
			 			classNames={{modal: 'order-modal' }}>
						<OrderListContainer product={product} showPaymentOption={false} showProductInfo={false} />
			 		</Modal>
				}
					
				
					

			</div>
	}
}

export default Radium(ProductDetail);




// WEBPACK FOOTER //
// ./src/views/product/ProductDetail.js